import React from 'react';
import style from './TabButtons.module.css';

const TabButtons = ({ children, className, variant }) => {
  return (
    <div className={`${style.wrapper} ${className} ${variant && style[variant]}`}>
      {children}
    </div>
  );
};

const Tab = ({ children, active, onClick }) => {
  return (
    <button className={`${style.button} ${active && style.active}`} onClick={onClick}>
      {children}
    </button>
  )
};

TabButtons.Tab = Tab;
export default TabButtons;
